import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
type PredictionResultProps = {
  prediction: {
    sizeResult: string;
    colorResult: string;
  };
  periodNumber: string;
};
export const PredictionResult = ({
  prediction,
  periodNumber
}: PredictionResultProps) => {
  const [showResult, setShowResult] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowResult(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  if (!showResult) {
    return <div className="h-40 flex items-center justify-center" data-id="element-21">
        <div className="animate-spin h-8 w-8 border-4 border-green-500 border-t-transparent rounded-full" data-id="element-22"></div>
      </div>;
  }
  return <motion.div className="border border-green-500 p-3 bg-black animate-glow" initial={{
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.3,
    type: 'spring'
  }} data-id="element-23">
      <motion.div className="text-center mb-3" initial={{
      y: -20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.3,
      delay: 0.1
    }} data-id="element-24">
        <div className="text-xs text-green-400 font-mono mb-1" data-id="element-25">
          PREDICTION RESULT FOR PERIOD
        </div>
        <div className="text-xl font-bold font-mono text-green-400 animate-pulse-custom" data-id="element-26">
          ***{periodNumber}
        </div>
      </motion.div>
      <div className="grid grid-cols-2 gap-4 mt-4" data-id="element-27">
        <motion.div className={`border p-3 text-center rounded-lg ${prediction.sizeResult === 'BIG' ? 'border-blue-500 bg-blue-500/10' : 'border-yellow-500 bg-yellow-500/10'}`} initial={{
        x: -50,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} whileHover={{
        scale: 1.05,
        boxShadow: '0 0 15px rgba(59, 130, 246, 0.5)'
      }} data-id="element-28">
          <div className="text-xs font-mono mb-1 text-green-400" data-id="element-29">SIZE</div>
          <div className={`text-xl font-bold font-mono ${prediction.sizeResult === 'BIG' ? 'text-blue-400' : 'text-yellow-400'}`} data-id="element-30">
            {prediction.sizeResult}
          </div>
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.6,
          type: 'spring'
        }} data-id="element-31">
            <CheckCircleIcon className={`mx-auto mt-1 ${prediction.sizeResult === 'BIG' ? 'text-blue-400' : 'text-yellow-400'}`} size={16} data-id="element-32" />
          </motion.div>
        </motion.div>
        <motion.div className={`border p-3 text-center rounded-lg ${prediction.colorResult === 'RED' ? 'border-red-500 bg-red-500/10' : 'border-green-600 bg-green-600/10'}`} initial={{
        x: 50,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} whileHover={{
        scale: 1.05,
        boxShadow: '0 0 15px rgba(239, 68, 68, 0.5)'
      }} data-id="element-33">
          <div className="text-xs font-mono mb-1 text-green-400" data-id="element-34">COLOR</div>
          <div className={`text-xl font-bold font-mono ${prediction.colorResult === 'RED' ? 'text-red-500' : 'text-green-600'}`} data-id="element-35">
            {prediction.colorResult}
          </div>
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.7,
          type: 'spring'
        }} data-id="element-36">
            <CheckCircleIcon className={`mx-auto mt-1 ${prediction.colorResult === 'RED' ? 'text-red-500' : 'text-green-600'}`} size={16} data-id="element-37" />
          </motion.div>
        </motion.div>
      </div>
      <motion.div className="mt-4 text-center" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.5
    }} data-id="element-38">
        <div className="flex items-center justify-center text-xs text-yellow-400 font-mono animate-pulse-custom" data-id="element-39">
          <AlertCircleIcon size={14} className="mr-1" data-id="element-40" />
          <span data-id="element-41">PREDICTION ACCURACY: 97.8%</span>
        </div>
      </motion.div>
    </motion.div>;
};